import { defineComponent as _defineComponent } from 'vue'
import BaseAutocomplete from "@/components-UI/BaseAutocomplete.vue";
import BaseSelect from "@/components-UI/BaseSelect.vue";
import BaseCombobox from "@/components-UI/BaseCombobox.vue";
import BaseInput from "@/components-UI/BaseInput.vue";
import BaseDateTimePicker from "@/components-UI/BaseDateTimePicker.vue";

export type FilterType = 'input' | 'select' | 'autocomplete' | 'combobox' | 'datetime';

type AvailableDates = { start: Date | null; end: Date | null; days?: number[] };
type UnknownItem = Record<string, unknown>;

export interface FilterConfig {
    type: FilterType;
    label?: string;
    placeholder?: string;
    disabled?: boolean;
    readonly?: boolean;
    clearable?: boolean;
    clearableType?: 'inner' | 'out';
    view?: 'border-bottom' | 'outlined' | 'empty';
    size?: 'small' | 'medium' | 'large';

    items?: UnknownItem[];
    itemValue?: string;
    itemLabel?: string;
    multiple?: boolean;
    template?: (item: UnknownItem) => string;
    isChip?: boolean;
    filterable?: boolean;

    apiMethod?: (value: any) => Promise<any>;
    delay?: number;
    minSearchLength?: number;
    isMultipaste?: boolean;
    isReturnObject?: boolean;
    triggerOnMounted?: boolean;
    searchKey?: 'search' | 'query';

    height?: number;
    maxItems?: number;

    format?: string;
    position?: 'top' | 'right' | 'bottom' | 'left';
    availableDates?: AvailableDates;
    /** Период (две даты), см. BaseDateTimePicker */
    range?: boolean;

    inputType?: string;
    mask?: string | Record<string, unknown>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FiltersDesign',
  props: {
    filter: null,
    value: null
  },
  emits: ["update:value", "update:chips", "select", "change", "clear"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'update:value', value: any): void;
    (e: 'update:chips', value: any): void;
    (e: 'select', payload: any): void;
    (e: 'change', value: any): void;
    (e: 'clear'): void;
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emits, BaseAutocomplete, BaseSelect, BaseCombobox, BaseInput, BaseDateTimePicker }
}

})